import { ThemeProvider } from "@mui/material";
import { getTheme } from "@src/appV2/redesign/system/ui-theme";

import { PageWrapper } from "../components/PageWrapper";
import { WorkWithFriendsRouter } from "./Router";
import { WorkWithFriendsProvider } from "./WorkWithFriendsContext";

export function WorkWithFriendsContainer() {
  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper>
        <WorkWithFriendsProvider>
          <WorkWithFriendsRouter />
        </WorkWithFriendsProvider>
      </PageWrapper>
    </ThemeProvider>
  );
}
